import { motion } from "framer-motion";
import { Sparkle, Flower2 } from "lucide-react";
import { scrollToSection, PORTRAIT_URL } from "../config";
import { useSite, resolveMedia } from "../siteContext";
import { SectionBackdrop } from "./SectionBackdrop";
import { useLang } from "../i18n";

export const CtaBanner = () => {
  const { lang } = useLang();
  const settings = useSite();
  const ar = lang === "ar";
  const portrait = resolveMedia(settings.portrait_url) || PORTRAIT_URL;
  return (
    <section data-testid="cta-banner" className="relative py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-[2.5rem] border border-luxury-gold/30 bg-luxury-surface px-8 py-16 md:py-24 text-center"
        >
          <SectionBackdrop id="cta" />
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[36rem] h-[36rem] rounded-full bg-luxury-gold/10 blur-3xl pointer-events-none" />
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="relative flex justify-center mb-6"
          >
            <Flower2 className="w-10 h-10 text-luxury-gold" strokeWidth={1} />
          </motion.div>
          <p className="relative text-luxury-gold text-sm tracking-[0.35em] mb-6">
            {ar ? "خطوتك الأولى" : "YOUR FIRST STEP"}
          </p>
          <h2 data-testid="cta-banner-title" className="relative font-serif font-bold text-4xl sm:text-5xl lg:text-6xl text-luxury-bone leading-[1.25] mb-6">
            {ar ? "جاهز/جاهزة لبدء" : "Ready to begin"}{" "}
            <span className="gold-shimmer italic">{ar ? "رحلتك؟" : "your journey?"}</span>
          </h2>
          <p className="relative text-luxury-gray text-base md:text-lg max-w-xl mx-auto leading-loose mb-10">
            {ar
              ? "رحلة السلام الداخلي والسعادة تبدأ باتخاذ الخطوة الأولى — مايا إلى جانبك لاتخاذها معك."
              : "The journey to inner peace and happiness begins with the first step — Maya is by your side to take it with you."}
          </p>
          <button
            data-testid="cta-banner-button"
            onClick={() => scrollToSection("contact")}
            className="relative inline-flex items-center gap-3 bg-luxury-gold text-luxury-black font-semibold px-10 py-4 rounded-full hover:bg-luxury-goldLight hover:scale-105 transition-all duration-300"
          >
            <Sparkle className="w-5 h-5" strokeWidth={1.5} />
            {ar ? "ابدأ/ابدئي الآن" : "Start now"}
          </button>
          <div
            data-testid="cta-banner-avatar"
            className="hidden lg:block absolute end-8 bottom-8 w-20 h-20 rounded-full overflow-hidden border-2 border-luxury-gold/60 shadow-[0_10px_30px_rgba(0,0,0,0.45)]"
          >
            <img src={portrait} alt="" className="w-full h-full object-cover object-top" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
